import Vue from 'vue';
import { MutationTree } from 'vuex';
import { iGame } from '@/entities/game/game.types';
import { iReview } from '@/entities/review/review.types';
import { GameState } from '../../types/game-module.types';

export enum GAME_MUTATIONS {
  SET_ACTIVE_GAME = 'SET_ACTIVE_GAME',
  SET_ACTIVE_GAME_REVIEWS = 'SET_ACTIVE_GAME_REVIEWS',
  SET_SEARCH_GAMES = 'SET_SEARCH_GAMES',
  SET_ACTIVE_GAME_RATING = 'SET_ACTIVE_GAME_RATING',
}

export const mutations: MutationTree<GameState> = {
  [GAME_MUTATIONS.SET_ACTIVE_GAME](state, value: iGame) {
    Vue.set(state, 'activeGame', value);
  },
  [GAME_MUTATIONS.SET_SEARCH_GAMES](state, games: iGame[]) {
    state.searchResults = games;
  },
  [GAME_MUTATIONS.SET_ACTIVE_GAME_REVIEWS](state, reviews: iReview[]) {
    state.activeGameReviews = reviews;
  },
  [GAME_MUTATIONS.SET_ACTIVE_GAME_RATING](state, rating: number) {
    state.activeGameRating = rating;
  },
};
